module.exports = __webpack_public_path__ + "img/a-max.f2fe9085.png";